import React, { useState } from 'react';
import { Button, Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';

const MessageInput = ({ sendMessage }) => {
  const [input, setInput] = useState('');

  const handleSendMessage = () => {
    const value = input;

    setInput('');
    sendMessage(value);
  };

  return (
    <Input
      placeholder="Aa"
      value={input}
      onChange={e => setInput(e.target.value)}
      suffix={
        <Button
          type="link"
          icon={<SendOutlined />}
          onClick={handleSendMessage}
        />
      }
      onPressEnter={handleSendMessage}
    />
  );
};

export default React.memo(MessageInput);
